export interface IPrimaryBorrowerBureau {
  isPreferredScoreSelected: boolean;
  preferredBureau: string;
  preferredScore: number;
  defaultBureau: string;
  defaultScore: number;
}

export class PrimaryBorrowerBureauModel implements Partial<IPrimaryBorrowerBureau> {
  isPreferredScoreSelected?: boolean;
  preferredBureau?: string;
  preferredScore?: number;
  defaultBureau?: string;
  defaultScore?: number;

  constructor(data?: Partial<IPrimaryBorrowerBureau>) {
    if (data) {
      this.isPreferredScoreSelected = data?.isPreferredScoreSelected;
      this.preferredBureau = data?.preferredBureau;
      this.preferredScore = data?.preferredScore;
      this.defaultBureau = data?.defaultBureau;
      this.defaultScore = data?.defaultScore;
    }
  }
}
